export type ProductId = string;
export type ProductVersionId = string;
export type ModelId = string;
export type ModelVersionId = string;
export type AttributeId = string;
export type AttributeValueId = string;
export type ComponentId = string;
export type ComponentInstanceId = string;
export type RuleId = string;
export type ConfigurationId = string;
export type WorkingConfigurationId = string;
export type SceneId = string;
export type NodeId = string;
export type MaterialId = string;
export type CameraId = string;
export type HotspotId = string;
export type AnimationId = string;
export type SlotId = string;
export type TenantId = string;
export type AccountId = string;
export type UserId = string;
export type VisitorId = string;
export type SessionId = string;
export type ViewerSessionId = string;
export type RequestId = string;
export type EventId = string;
export type CommandId = string;
export type CorrelationId = string;

export interface KeyedEntity {
  id: string;
  key: string;
  label: string;
}
